export default __webpack_public_path__ + "static/media/50_3_1.ac49a44e.png";